import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import LangContextProvider from "./Context/LangContext";
// bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';

// main style index 
import "./index.css";
import "./Style/Responsive.css";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LangContextProvider>
      <App />
    </LangContextProvider>
  </React.StrictMode>
);
